import {
    Cashier,
    TransactionCashier,
    CashierReports,
    CashierAssignment,
    CashierOperations,
    CashierOperationDetails,
    CashierManagement,
    CashierManagementForm
} from "../components/Cashier";

const routesCashier = [
    {
        path: "/cajas/catalogo",
        name: "Cajas",
        icon: "nc-icon nc-bank",
        component: <Cashier />,
        permissions: ['164_CAJAS_CATALOGO'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
    },
    {
        path: "/cajas/transacciones",
        name: "Transacciones",
        icon: "nc-icon nc-bank",
        component: <TransactionCashier />,
        permissions: ['165_MOVIMIENTO_DE_CAJAS'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
    },
    {
        path: "/cajas/reportes",
        name: "Reportes",
        icon: "nc-icon nc-bank",
        component: <CashierReports />,
        permissions: ['255_REPORTES'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
    },
    {
        path: "/cajas/asignacion",
        name: "Asignación",
        icon: "nc-icon nc-bank",
        component: <CashierAssignment />,
        permissions: ['243_ASIGNACION'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
    },
    {
        path: "/cajas/operaciones",
        name: "Operaciones",
        icon: "nc-icon nc-bank",
        component: <CashierOperations />,
        permissions: ['244_OPERACIONES'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
    },
    {
        path: "/cajas/operaciones/detalles/:idoperacion",
        name: "Detalles de Operaciones",
        icon: "nc-icon nc-bank",
        component: <CashierOperationDetails />,
        permissions: ['244_OPERACIONES'],
        layout: "/app",
        visibility: false,
        subRoutes: [],
    },
    {
        path: "/cajas/gestiones",
        name: "Gestiones",
        icon: "nc-icon nc-bank",
        component: <CashierManagement />,
        permissions: ['245_GESTIONES'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
    },
    {
        path: "/cajas/gestiones/formulario",
        name: "Gestiones",
        icon: "nc-icon nc-bank",
        component: <CashierManagementForm />,
        permissions: ['245_GESTIONES'],
        layout: "/app",
        visibility: false,
        subRoutes: [],
    },
    {
        path: "/cajas/gestiones/formulario/:idgestion",
        name: "Gestiones",
        icon: "nc-icon nc-bank",
        component: <CashierManagementForm />,
        permissions: ['245_GESTIONES'],
        layout: "/app",
        visibility: false,
        subRoutes: [],
    },
]

export {
    routesCashier
}
